import { PAYMENT_METHOD_TYPE } from '@linqpal/models/src/dictionaries'

interface PaymentMethod {
  id: string
  name: string
  accountNumber?: string
  accountType?: string
  paymentMethodType: typeof PAYMENT_METHOD_TYPE[keyof typeof PAYMENT_METHOD_TYPE]
  cardMetadata?: {
    type: string
    lastFour?: string
  }
}

interface PaymentMethodMetadata {
  name: string
  subtitle: string
  displayNumber: string
  type: string
}

export const getPaymentMethodMetadata = (
  paymentMethod: PaymentMethod,
  t: (key: string, options?: any) => string,
): PaymentMethodMetadata => {
  if (paymentMethod.paymentMethodType === PAYMENT_METHOD_TYPE.BANK) {
    const accNum = paymentMethod.accountNumber?.slice(-3) || ''
    return {
      name: paymentMethod.name,
      subtitle:
        paymentMethod.accountType === 'savings'
          ? t('PaymentMethodsListing.business-saving', { accNum })
          : t('PaymentMethodsListing.business-checking', { accNum }),
      displayNumber: `...${paymentMethod.accountNumber?.slice(-3) || ''}`,
      type: paymentMethod.accountType || 'checking',
    }
  }

  if (paymentMethod.paymentMethodType === PAYMENT_METHOD_TYPE.CARD) {
    const accNum =
      paymentMethod.cardMetadata?.lastFour ||
      paymentMethod.accountNumber?.slice(-4) ||
      ''
    return {
      name: paymentMethod.name,
      subtitle:
        paymentMethod.cardMetadata?.type === 'Debit'
          ? t('PaymentMethodsListing.debit-card', { accNum })
          : t('PaymentMethodsListing.credit-card', { accNum }),
      displayNumber: `...${accNum}`,
      type: paymentMethod.cardMetadata?.type || 'Credit',
    }
  }

  return {
    name: '',
    subtitle: '',
    displayNumber: '',
    type: '',
  }
}
